function getFileNameFromURL(url: string) {
  return url?.split('/')?.pop()?.split(/\?|#/)?.shift();
}

export default getFileNameFromURL;
